import { render, staticRenderFns } from "./ReservePatientAppointments.vue?vue&type=template&id=578edba0&scoped=true"
import script from "./ReservePatientAppointments.vue?vue&type=script&lang=js"
export * from "./ReservePatientAppointments.vue?vue&type=script&lang=js"
import style0 from "./ReservePatientAppointments.vue?vue&type=style&index=0&id=578edba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578edba0",
  null
  
)

export default component.exports